/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;display:flex;flex-direction:column}[_nghost-%COMP%]   .media-container[_ngcontent-%COMP%]{border-radius:inherit}[_nghost-%COMP%]   .media-container.caption[_ngcontent-%COMP%]{border-bottom-left-radius:0;border-bottom-right-radius:0}[_nghost-%COMP%]   .caption-box[_ngcontent-%COMP%]{padding:6px 15px}"];
export { styles as styles };
